import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle, Scale, FileText } from 'lucide-react';

const Legal = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <Link
          to="/"
          className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Retour au simulateur
        </Link>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Mentions légales</h1>

          <div className="prose max-w-none text-gray-600 space-y-8">
            <div className="bg-yellow-50 p-6 rounded-lg border-l-4 border-yellow-400">
              <div className="flex items-center mb-4">
                <AlertTriangle className="w-6 h-6 text-yellow-600 mr-2" />
                <h2 className="text-lg font-semibold text-yellow-900">Avertissement important</h2>
              </div>
              <p className="text-yellow-800">
                Ce simulateur est fourni à titre informatif uniquement. Les résultats des calculs sont des estimations basées sur les taux et barèmes en vigueur, mais ne constituent pas un conseil juridique ou fiscal personnalisé.
              </p>
              <p className="text-yellow-800 mt-4 font-medium">
                Il est recommandé de consulter un expert-comptable ou un conseiller juridique pour toute décision concernant votre statut juridique.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <Scale className="w-6 h-6 text-gray-600 mr-2" />
                  <h2 className="text-lg font-semibold text-gray-900">Responsabilité</h2>
                </div>
                <p className="text-gray-700">
                  Bien que nous nous efforcions de maintenir les informations à jour et exactes, nous ne pouvons garantir l'exactitude des résultats. Les calculs sont basés sur les informations disponibles au moment de la consultation.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="flex items-center mb-4">
                  <FileText className="w-6 h-6 text-gray-600 mr-2" />
                  <h2 className="text-lg font-semibold text-gray-900">Cadre légal</h2>
                </div>
                <p className="text-gray-700">
                  L'utilisation de ce simulateur ne crée aucune relation contractuelle entre l'utilisateur et le fournisseur du service.
                </p>
              </div>
            </div>

            <h2 className="text-xl font-semibold text-gray-900 mt-8">Mises à jour</h2>
            <p>
              Les informations et calculs présentés sont susceptibles d'évoluer en fonction des changements législatifs. Nous nous efforçons de maintenir le simulateur à jour avec les dernières réglementations en vigueur.
            </p>

            <h2 className="text-xl font-semibold text-gray-900">Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce simulateur (textes, calculs, algorithmes, design) est protégé par le droit de la propriété intellectuelle. Toute reproduction ou utilisation non autorisée est interdite.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Legal;